import React from 'react'
import { Outlet } from 'react-router-dom'

function MainTestingAndCommissioning() {
  return (
    <div>
      <Outlet/>
    </div>
  )
}

export default MainTestingAndCommissioning
